import React from "react";
import { Navigate } from "react-router-dom";

export const RedirectRoute = ({ to, ...rest }) => {
  return <Navigate to={to} {...rest} />;
};
